import { render, staticRenderFns } from "./DetailAd.vue?vue&type=template&id=41be8f24&scoped=true&"
import script from "./DetailAd.vue?vue&type=script&lang=js&"
export * from "./DetailAd.vue?vue&type=script&lang=js&"
import style0 from "./DetailAd.vue?vue&type=style&index=0&id=41be8f24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be8f24",
  null
  
)

export default component.exports